// extracted by mini-css-extract-plugin
module.exports = {"gray":"text_gray__1V-Jz","black":"text_black__32eCQ"};